export default __webpack_public_path__ + "static/media/angle-down.d660b404.svg";